export default __webpack_public_path__ + "static/apps-4b4d9b7d097bf0f34874a49b758c345a.png";